<div fxLayout="column" fxLayoutGap="10px"  class=" layout-padd-20-button ">

   
    <!-- Error message -->
    <div *ngIf="errorMessage" class="layout-padd warn rad-bord text-center">
        <span class="mat-subheading-1">{{errorMessage}}</span>
    </div>

    <div #paypal></div>

    

</div>
